// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".skeleton-tab-bar[data-v-60734da0]{background-color:#fff;display:flex;justify-content:space-between;margin-top:5px;padding:20px}.skeleton-tab-bar .left[data-v-60734da0]{width:100px}.skeleton-tab-bar .right[data-v-60734da0]{width:80px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
